import baseRequired from './contraint/required';

type FieldType = 'int' | 'string' | 'object' | 'array' | 'html';

export interface ValidationConstraints {
  [constraintName: string]: any;
}

export type FieldValidationSchema = {
  type: FieldType,
  constraints: ValidationConstraints,
  // eslint-disable-next-line no-use-before-define
  properties?: ValidationSchema,
  // eslint-disable-next-line no-use-before-define
  arrayItemSchema?: ValidationSchema
}

export interface ValidationSchema {
  [fieldName: string]: FieldValidationSchema;
}

export type ConstraintValue<Type = any> = Type | {
  value: Type,
  message: string
}

export type ValidateMethodFunc<ConstraintValueType = any> = (
  _object: Record<string, any>,
  _fieldName: string,
  _constraintConfiguration: ConstraintValue<ConstraintValueType>
) => boolean;

export interface ConstraintValidator<ConstraintValueType = any> {
  getName: () => string,
  validate: ValidateMethodFunc<ConstraintValueType>,
  getErrorMessage: (constraintConfiguration: ConstraintValueType) => string,
}


export function useRequiredConstraintValidator() {
  return baseRequired();
}
